import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const RENEWALS_BASE_PATH_API = `${BASE_PATH_API}/renewals`;

const actions = {
    getLeaseFromRenewal: {
        method: 'GET',
        url: `${RENEWALS_BASE_PATH_API}/:renewalId/lease`
    },
    updateComment: {
        method: 'PUT',
        url: `${RENEWALS_BASE_PATH_API}/:id/comment`
    },
    getRenewal: {
        method: 'GET',
        url: `${RENEWALS_BASE_PATH_API}/:id`
    },
    getAgreementFiles: {
        method: 'GET',
        url: `${RENEWALS_BASE_PATH_API}/:id/agreements/files`,
        isArray: true
    },
    getELeaseAgreements: {
        method: 'GET',
        url: `${RENEWALS_BASE_PATH_API}/:id/agreements`,
        isArray: true
    },
    getCurrentELeaseAgreement: {
        method: 'GET',
        url: `${RENEWALS_BASE_PATH_API}/:id/agreements/current`,
        isArray: true
    },
    getLatestELeaseAgreement: {
        method: 'GET',
        url: `${RENEWALS_BASE_PATH_API}/:id/agreements/:agreementId/refresh`
    },
    saveFile: {
        method: 'POST',
        url: `${RENEWALS_BASE_PATH_API}/:id/agreements/files`
    },
    deleteFile: {
        method: 'DELETE',
        url: `${RENEWALS_BASE_PATH_API}/:id/agreements/files/:entityTypeId/:fileId`
    },
    createELeaseAgreement: {
        method: 'POST',
        url: `${RENEWALS_BASE_PATH_API}s/:id/agreements`
    },
    getPendingTokens: {
        method: 'POST',
        url: `${RENEWALS_BASE_PATH_API}/:id/templateTokens`
    },
    cancelELeaseAgreement: {
        method: 'DELETE',
        url: `${RENEWALS_BASE_PATH_API}/:id/agreements/:agreementId`
    },
    updateLeaseTerms: {
        method: 'PUT',
        url: `${RENEWALS_BASE_PATH_API}/:id/terms`
    },
    updateLeaseRenewal: {
        method: 'PUT',
        url: `${RENEWALS_BASE_PATH_API}/:id`
    },
    getRent: {
        method: 'GET',
        url: `${RENEWALS_BASE_PATH_API}/:id/rent`
    },
    updateRent: {
        method: 'PUT',
        url: `${RENEWALS_BASE_PATH_API}/:id/rent`
    },
    associateRentToRenewal: {
        method: 'PUT',
        url: `${RENEWALS_BASE_PATH_API}/:renewalId/rent/:rentId`
    },
    createOffers: {
        method: 'POST',
        url: `${RENEWALS_BASE_PATH_API}/bulk/offers`
    },
    updateOfferComment: {
        method: 'PATCH',
        url: `${RENEWALS_BASE_PATH_API}/offer/:offerId`
    },
    bulkUpdateRenewalOffers: {
        method: 'PUT',
        url: `${RENEWALS_BASE_PATH_API}/bulk/offers`
    },
    deleteRenewalOffer: {
        method: 'DELETE',
        url: `${RENEWALS_BASE_PATH_API}/offer/:leaseId`
    },
    getDefaultTerms: {
        method: 'GET',
        url: `${RENEWALS_BASE_PATH_API}/terms`
    }
};

export function RenewalsApi() {
    return createActions(actions);
}
